module.exports = __webpack_public_path__ + "img/kc15.08fab4be.png";